import React from 'react';
import type { IconProps } from '../types';

export const OrientationSwitchC = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.57766 17.4182L9.4655 19.8288L6.80457 21.4557"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5918 15C19.8503 15.1669 20.067 15.3909 20.2253 15.6547C20.3836 15.9186 20.4793 16.2152 20.5049 16.5218C20.5049 18.3123 16.991 19.7938 12.5153 19.946"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.46782 19.828C5.73931 19.4354 3 18.1038 3 16.5218C3.02464 16.2179 3.11841 15.9236 3.27416 15.6614C3.4299 15.3992 3.6435 15.1761 3.89865 15.0091"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1735 15.1523C9.52649 15.1523 7.89514 13.356 7.89514 10.417C7.89514 7.49707 9.55188 5.68799 12.1417 5.68799C13.8365 5.68799 15.1759 6.48145 15.7789 7.8208C15.8805 8.03027 15.9313 8.24609 15.9313 8.43652C15.9313 8.87451 15.6456 9.15381 15.2076 9.15381C14.8331 9.15381 14.5856 8.97607 14.4078 8.57617C13.9825 7.59229 13.151 7.07812 12.1544 7.07812C10.5802 7.07812 9.57092 8.37305 9.57092 10.417C9.57092 12.4736 10.5739 13.7622 12.1608 13.7622C13.2081 13.7622 14.0143 13.3052 14.4332 12.3403C14.5983 11.9658 14.8077 11.8135 15.1632 11.8135C15.6139 11.8135 15.9249 12.1118 15.9249 12.5435C15.9249 12.7529 15.8741 12.9434 15.7726 13.1592C15.1886 14.4033 13.8873 15.1523 12.1735 15.1523Z"
      fill="currentColor"
    />
  </svg>
);

export default OrientationSwitchC;
